import { formatPrice, type Language, type OrderDto } from '@posilka/shared';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { formatWindow } from '@posilka/client/lib/time';
import { cityName } from '@posilka/client/lib/cities';
import { Icon } from './Icon';
import { StatusBadge } from './StatusBadge';

export function OrderCard({ order, to }: { order: OrderDto; to: string }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language as Language;
  const [broken, setBroken] = useState(false);
  const thumb = broken ? undefined : order.photoUrls[0];
  return (
    <Link to={to} className="card press mb-3 flex animate-fade-up gap-3.5 p-3.5">
      <div className="h-[72px] w-[72px] shrink-0 overflow-hidden rounded-2xl bg-surface-2">
        {thumb ? (
          <img
            src={thumb}
            alt=""
            className="h-full w-full object-cover"
            loading="lazy"
            onError={() => setBroken(true)}
          />
        ) : (
          <span className="flex h-full items-center justify-center text-muted">
            <Icon name="box" className="h-8 w-8" strokeWidth={1.4} />
          </span>
        )}
      </div>
      <div className="min-w-0 flex-1">
        <p className="font-display text-[15px] leading-snug font-bold">
          {cityName(order.fromCity, lang)} <span className="text-accent">→</span>{' '}
          {cityName(order.toCity, lang)}
        </p>
        <p className="mt-0.5 text-sm text-muted">
          {formatWindow(order.pickupFrom, order.pickupTo, lang)}
        </p>
        <p className="truncate text-sm text-muted">
          {t(`category.${order.category}`)} · {order.sizeClass} · {order.publicNumber}
        </p>
        <div className="mt-2 flex items-center justify-between gap-2">
          <StatusBadge status={order.status} />
          <span className="font-display font-bold whitespace-nowrap">
            {formatPrice(order.price, t('common.currency'))}
          </span>
        </div>
      </div>
    </Link>
  );
}
